module.exports = __webpack_public_path__ + "static/media/medium.c89321d4.png";